app.headerController = app.headerController || {};
app.headerController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.scrollHeader();
        this.fixedHeader();
        this.mainNav();
    },

    scrollHeader : function () {
        $('.siteHeaderSeeMore').on(app.clickEvent, function (e) {
            $('html, body').animate({
                scrollTop: $($(this).attr("href")).offset().top-$(".mainNavMenu").innerHeight()+1
            }, 400);
            e.preventDefault();
        });
    },

    fixedHeader : function () {
        var scrollOffset = function() { return $(document).scrollTop(); },
            $siteHeader = $('.siteHeader');

        function scrollStatus () {
            if ( scrollOffset() > $siteHeader.innerHeight()) {
                $('body').addClass('is-scrolling');
            }
            else {
                $('body').removeClass('is-scrolling');
            }
        }

        scrollStatus();

        $(document).on('scroll', function() {
            scrollStatus();
        });
    },

    mainNav : function () {
        //
        // ***** SpyNav *****
        //

        // Cache selectors
        var lastId,
            topMenu = $(".mainNavMenu"),
            fixedOffset = topMenu.innerHeight(),
            // All list items
            menuItems = topMenu.find(".mainNavLink"),
            // Anchors corresponding to menu items
            scrollItems = menuItems.map(function(){
                var item = $($(this).attr("href"));
                if (item.length) { return item; }
            });

        // Toggle .mainNavMenu class on click
        $('.mainNavLink').on(app.clickEvent, function (e) {
            e.preventDefault();
            if ($(this).parent('.mainNavItem').hasClass('is-active')) {
                $target = $(e.target);
                topMenu.toggleClass('is-active');
            }
        });
        $('body').on(app.clickEvent, function (e) {
            $target = $(e.target);
            if($target.parents('.mainNav').length < 1) {
                topMenu.removeClass('is-active');
            }
        });

        // Bind click handler to menu items
        // so we can get a fancy scroll animation
        menuItems.click(function(e){
            if (!$(this).parent('.mainNavItem').hasClass('is-active')) {
                var href = $(this).attr("href"),
                    offsetTop = href === "#" ? 0 : $(href).offset().top-fixedOffset+1;
                $('html, body').stop().animate({
                    scrollTop: offsetTop
                }, 300);
                e.preventDefault();
                topMenu.removeClass('is-active');
            }
        });

        // Bind to scroll
        $(window).scroll(function(){
            // Get container scroll position
            var fromTop = $(this).scrollTop()+fixedOffset;

            // Get id of current scroll item
            var cur = scrollItems.map(function(){
                if ($(this).offset().top < fromTop)
                    return this;
            });
            // Get the id of the current element
            cur = cur[cur.length-1];
            var id = cur && cur.length ? cur[0].id : "";

            if (lastId !== id) {
                lastId = id;
                // Set/remove active class
                if (menuItems.filter("[href='#"+id+"']").length > 0) {
                    var $activeItem = menuItems.filter("[href='#"+id+"']");
                    $activeItem.parent('.mainNavItem').siblings().removeClass("is-active");
                    $activeItem.parent('.mainNavItem').addClass("is-active");
                }
            }
        });
    },

};

$(document).ready(function(){
    app.headerController.defaultAction.init();
});